import { getNextStepIndex, resolveVisibleStepIndex } from "./handlers";

import { IAppContext } from "../../util/context";
import { StepData } from "../FormViewer/FormViewer.types";
import { trackEvent } from "../../util/functions";

export const handleStepTransition = (context: IAppContext, stepData: StepData) => {
  const { steps, activeStepIndex, updateActiveStepIndex, updateBreadcrumb } = context;
  const targetIndex = getNextStepIndex(activeStepIndex, stepData, steps, context);
  if (!steps[targetIndex]) return ;

  const nextIndex = resolveVisibleStepIndex(steps, targetIndex);

  if(nextIndex === 1 && steps.length > 1) {
    trackEvent("formClient.started");
  }

  updateActiveStepIndex(nextIndex);
  updateBreadcrumb(nextIndex);
}